import type { FC, HTMLProps, ReactNode } from "react";

import * as styles from "./Container.styles";

interface Props extends HTMLProps<HTMLDivElement> {
  /**
   * Adjust the possible max-width of the container
   *
   * @default null
   */
  type?: "small";
  /**
   * Adjusts the maximum possible width if the page utilizes a sidebar
   *
   * @default false
   */
  withSidebar?: boolean;
  /**
   * Content to render inside a container
   *
   * @default undefined
   */
  children?: ReactNode;
}

const Container: FC<Props> = ({ withSidebar, type, children, ...rest }) => {
  const conditionalStyles = [
    styles.containerDiv,
    type && styles.types[type],
    withSidebar && styles.withSidebar,
  ];

  return (
    <div css={conditionalStyles} {...rest}>
      {children}
    </div>
  );
};

export { Container };
